import { EventBus } from '@/game/GameComponents/PhaserGame/EventBus';

export default class EventsManager {
  static Instance?: EventsManager;

  constructor() {
    if (EventsManager.Instance !== undefined) {
      console.error('events manager already initialized');
      return;
    }
    EventsManager.Instance = this;
  }

  private registerEvent(
    scene: Phaser.Scene,
    event: string,
    callback: (...args: any[]) => void,
    scope: any,
    condition: (
      event: string | symbol,
      fn: Function,
      context?: any,
    ) => Phaser.Events.EventEmitter,
  ) {
    condition.call(EventBus, event, callback, scope);
    if (!scene) {
      console.error(
        'Scene is undefined when registering event',
        event,
        callback.name,
      );
      return;
    }

    if (!scene.events) {
      console.error(
        'Scene events are undefined when registering event',
        event,
        callback.name,
      );
      return;
    }

    scene.events.once('destroy', () => {
      EventBus.off(event, callback, scope);
    });

    scene.events.once('shutdown', () => {
      EventBus.off(event, callback, scope);
    });
  }

  // Registers a callback to the EventsManagerInstance to handle the event every time it fires.
  static registerEventOn(
    scene: Phaser.Scene,
    event: string,
    callback: (...args: any[]) => void,
    scope: any,
  ) {
    if (!EventsManager.Instance) {
      console.error('events manager not initialized');
      return;
    }
    EventsManager.Instance.registerEvent(
      scene,
      event,
      callback,
      scope,
      EventBus.on.bind(EventBus),
    );
  }

  // Registers a callback to the EventsManagerInstance to handle the event only once.
  static registerEventOnce(
    scene: Phaser.Scene,
    event: string,
    callback: (...args: any[]) => void,
    scope: any,
  ) {
    if (!EventsManager.Instance) {
      console.error('events manager not initialized');
      return;
    }
    EventsManager.Instance.registerEvent(
      scene,
      event,
      callback,
      scope,
      EventBus.once.bind(EventBus),
    );
  }

  static destroyEventsManager() {
    EventsManager.Instance = undefined;
  }
}
